/* eslint-disable */
export default {
  close: 'Cerrar',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
